import type { Invoice } from '../Invoices.types';
import { useInvoicePayment } from '@/features/Profile/sections/Packages/hooks';
import {
  useBusinessBalance,
  useCurrentUser,
} from '@/features/Profile/core/hooks';

type UseInvoiceListPaymentParams = {
  invoice: Invoice | null;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export function useInvoiceListPayment({
  invoice,
  isOpen,
  onClose,
  onSuccess,
}: UseInvoiceListPaymentParams) {
  const { loading: isCurrentUserLoading, user } = useCurrentUser();
  const {
    cashBalance,
    loading: isBalanceLoading,
    refetchBalance,
  } = useBusinessBalance();
  const controller = useInvoicePayment({
    amount: invoice?.amount ?? 0,
    getInvoice: () =>
      Promise.resolve(
        invoice
          ? {
              amount: invoice.amount,
              id: invoice.id,
              legacyResourceId: invoice.number,
            }
          : null
      ),
    isAppleGooglePayEnabled: user.isAppleGooglePayEnabled,
    isOpen,
    onBalanceTopUpSuccess: () => {
      refetchBalance();
    },
    onClose,
    onSuccess,
    paymentMethods: user.paymentMethods,
    serviceName: invoice?.service ?? '',
  });

  return {
    cashBalance,
    controller,
    isLoading:
      isCurrentUserLoading ||
      isBalanceLoading ||
      controller.isProcessingPayment,
  };
}
